import { ActionStatus } from '@pmp/api';
import { ImportsPageAction, ImportsPageState } from './interfaces';

export const initialState: ImportsPageState = {
  deleteModal: { open: false, record: null },
  importModal: { open: false, importId: null, creationTime: null, status: null, readOnly: false, entityType: null },
  importMatching: { open: false, entityType: null, mode: null },
};

export function reducer(prevState: ImportsPageState, action: ImportsPageAction): ImportsPageState {
  switch (action.type) {
    case 'openDeleteModal':
      if (action.record === undefined) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...initialState,
        deleteModal: { open: true, record: action.record },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: { open: false, record: null },
      };
    case 'openImportModal':
      if ((action.record && (!action.record.importId || !action.record.creationTime || !action.record.status)) || !action.entityType)
        throw new Error(`Invalid action provided ${action.type}`);

      return {
        ...prevState,
        importModal: {
          open: true,
          importId: action.record?.importId ?? null,
          creationTime: action.record?.creationTime ?? null,
          status: (action.record?.status?.key ?? null) as ActionStatus | null,
          entityType: action.entityType,
          readOnly: action.readOnly ?? false,
        },
      };
    case 'closeImportModal':
      return {
        ...prevState,
        importModal: {
          open: false,
          importId: null,
          creationTime: null,
          status: null,
          readOnly: false,
          entityType: null,
        },
      };
    case 'openImportMatching':
      if (!action.mode || !action.entityType) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        importMatching: {
          open: true,
          entityType: action.entityType,
          mode: action.mode,
        },
      };
    case 'closeImportMatching':
      return {
        ...prevState,
        importMatching: {
          open: false,
          entityType: null,
          mode: null,
        },
      };

    default:
      throw new Error('No action provided');
  }
}
